module.exports = __webpack_public_path__ + "img/home-changes-inner.5c7f04db.png";